"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.globalStyles = void 0;
var react_1 = require("@emotion/react");
var spoqaHanSansNeo_1 = __importDefault(require("@/styles/fonts/spoqaHanSansNeo"));
var resetCss_1 = __importDefault(require("./resetCss"));
var editorCss_1 = __importDefault(require("./editorCss"));
exports.globalStyles = (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  ", "\n  ", "\n  #root {\n    min-width: 89.6rem;\n  }\n"], ["\n  ", "\n  ", "\n  ", "\n  #root {\n    min-width: 89.6rem;\n  }\n"])), spoqaHanSansNeo_1.default, resetCss_1.default, editorCss_1.default);
var templateObject_1;
